<div part="avatar" class="avatar" [style.background-color]="avatarColor">
    {{avatarName | uppercase }}
</div>